import { FC } from "react";

const VideoFileImageIllustration: FC = () => {
  return (
    <svg
      width="129"
      height="129"
      viewBox="0 0 129 129"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.11108 49.8889C7.11108 44.4869 11.489 40.1111 16.8889 40.1111H47.1111C52.5109 40.1111 56.8889 44.4869 56.8889 49.8889V80.1111C56.8889 85.513 52.5109 89.8889 47.1111 89.8889H16.8889C11.489 89.8889 7.11108 85.513 7.11108 80.1111L7.11108 49.8889Z"
        fill="#775172"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.1111 57.4303C23.1111 53.9958 26.8361 51.8669 29.7939 53.5901L42.7761 61.1604C42.832 61.1931 42.8867 61.2276 42.9397 61.2638C45.7162 63.0387 45.6618 67.1605 42.7761 68.8433L29.7949 76.413C26.8371 78.1361 23.1111 76.0081 23.1111 72.5734V65.0018V57.4303Z"
        fill="#51184D"
      />
      <path
        d="M109.667 72.8889H72.3338C66.9337 72.8889 62.556 77.2666 62.556 82.6667V109.333C62.556 114.734 66.9337 119.111 72.3338 119.111H109.667C115.067 119.111 119.445 114.734 119.445 109.333V82.6667C119.445 77.2666 115.067 72.8889 109.667 72.8889Z"
        fill="#AEBEFD"
      />
      <path
        d="M105.914 93.8092C102.101 89.9966 95.8996 89.9966 92.087 93.8092L67.8982 117.998C69.2358 118.686 70.7288 119.111 72.3334 119.111H109.667C115.059 119.111 119.445 114.726 119.445 109.333V107.341L105.914 93.8092Z"
        fill="#4677F5"
      />
      <path
        d="M79.4449 94.2221C81.8995 94.2221 83.8894 92.2323 83.8894 89.7777C83.8894 87.3231 81.8995 85.3333 79.4449 85.3333C76.9904 85.3333 75.0005 87.3231 75.0005 89.7777C75.0005 92.2323 76.9904 94.2221 79.4449 94.2221Z"
        fill="#4677F5"
      />
      <path
        d="M113.065 24.2961L99.1449 10.3761C97.9793 9.21024 96.3986 8.55566 94.7502 8.55566H74.8889C69.4887 8.55566 65.1111 12.9333 65.1111 18.3334V55.6668C65.1111 61.067 69.4887 65.4446 74.8889 65.4446H105.111C110.511 65.4446 114.889 61.067 114.889 55.6668V28.6997C114.889 27.0478 114.233 25.4634 113.065 24.2961Z"
        fill="#FEDA65"
      />
      <path
        d="M114.423 26.3369H100.667C98.7111 26.3369 97.1111 24.7369 97.1111 22.7814V9.02148C97.8649 9.331 98.5575 9.78863 99.1449 10.3761L113.065 24.2961C113.654 24.8851 114.113 25.5804 114.423 26.3369Z"
        fill="#B49000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.7777 29.0002C75.7777 27.5274 76.9716 26.3335 78.4444 26.3335H85.5555C87.0282 26.3335 88.2222 27.5274 88.2222 29.0002C88.2222 30.4729 87.0282 31.6668 85.5555 31.6668H78.4444C76.9716 31.6668 75.7777 30.4729 75.7777 29.0002Z"
        fill="#B49000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.7777 39.6667C75.7777 38.1939 76.9716 37 78.4444 37H101.555C103.028 37 104.222 38.1939 104.222 39.6667C104.222 41.1394 103.028 42.3333 101.555 42.3333H78.4444C76.9716 42.3333 75.7777 41.1394 75.7777 39.6667Z"
        fill="#B49000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.7777 50.3334C75.7777 48.8607 76.9716 47.6667 78.4444 47.6667H101.555C103.028 47.6667 104.222 48.8607 104.222 50.3334C104.222 51.8061 103.028 53.0001 101.555 53.0001H78.4444C76.9716 53.0001 75.7777 51.8061 75.7777 50.3334Z"
        fill="#B49000"
      />
    </svg>
  );
};

export default VideoFileImageIllustration;
